import { useEffect, useState } from 'react';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
import { addConnectionStatusListener, CALLING_CONNECTION_STATUS_UPDATE, removeConnectionStatusListener } from './connectionEvents';
import { waitForSharedWorkerConnectionSingleton } from './waitForSharedWorkerConnectionSingleton';
export const useConnectionStatus = instance => {
  const [connectionStatus, setConnectionStatus] = useState(ConnectionStatusTypes.UNINITIALIZED);
  useEffect(() => {
    let mounted = true;
    if (instance) {
      setConnectionStatus(instance.connectionStatus);
    } else {
      waitForSharedWorkerConnectionSingleton().then(asyncInstance => {
        if (!mounted) return;
        if (asyncInstance) {
          setConnectionStatus(asyncInstance.connectionStatus);
          return;
        }
        setConnectionStatus(ConnectionStatusTypes.FAILED);
      }).catch(() => {
        setConnectionStatus(ConnectionStatusTypes.FAILED);
      });
    }
    return () => {
      mounted = false;
    };
  }, [instance]);
  useEffect(() => {
    const connectionStatusUpdate = evt => {
      if (evt.type === CALLING_CONNECTION_STATUS_UPDATE && evt.detail && evt.detail.status) {
        setConnectionStatus(evt.detail.status);
      }
    };
    addConnectionStatusListener(connectionStatusUpdate);
    return () => {
      removeConnectionStatusListener(connectionStatusUpdate);
    };
  }, []);
  return connectionStatus;
};